<div class="border p-2">
  <div class="label pl-2">
    <label>{{ config.label }}</label>
  </div>
  <div class="d-inline-flex pl-2">
    <mat-radio-group ngDefaultControl [formControl]="controle" style="padding-right: 4em;">
      @for (optionValue of config.values; track optionValue) {
        <mat-radio-button class="mr-2"
          [value]="optionValue.value"
          [disabled]="disabled"
          (change)="atualizaControle($event)">
          {{ optionValue.text }}
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>
</div>

